import React, { Component } from "react";
import Select from "react-select";
import ReactTable from "react-table";
import axios from "axios";
import SweetAlert from "react-bootstrap-sweetalert";
import HmacSHA256 from "crypto-js/hmac-sha256";
import LoadingSpinner from "../components/Input/LoadingSpinner"


class ShperndaKorrier extends Component {
  state = {
    PodKodi: [],
    posts: [],
    Perdorues: "",
    data2: [],
    Korrieri: "",
    errors: "",
    alert: null,
    statusi: [],
    selected: false,
    agjensi: "",
    loading: false,
    loading2: false,
    Agjensi: "",
  };

  showErrors() {
    const getAlert = () => (
      <SweetAlert
        success
        title="Kujdes!"
        closeOnClickOutside={false}
        onConfirm={() => this.hideAlert()}
        onCancel={() => this.hideAlert()}
        showCancel
      >
        {this.state.errors}
      </SweetAlert>
    );

    this.setState({
      alert: getAlert(),
    });
  }
  hideAlert() {
 
    this.setState({
      alert: null,
    });
  }

  handleValidation(param) {
    let errors = {};
    let formIsValid = true;
    if (this.state.PodKodi.length == 0) {
      formIsValid = false;
      errors["name"] = "Ju lutem vendosni podin!";
      document.getElementById("PodKodi").style.borderColor = "red";
    } else if (this.state.PodKodi.length > 1 && this.state.PodKodi.length < 7) {
      formIsValid = false;
      document.getElementById("PodKodi").style.borderColor = "red";
      errors["name"] = "Numri i pod-it nuk eshte i sakte!";
    } else if (this.state.PodKodi.length > 1 && this.state.PodKodi.length < 7) {
      formIsValid = false;
      errors["name"] = "Numri i pod-it nuk eshte i sakte!";
      document.getElementById("PodKodi").style.borderColor = "red";
    } else if (param.includes(this.state.PodKodi)) {
      formIsValid = false;
      errors["name"] = "Numri i pod-it eshte shtuar 1 here!";
      document.getElementById("PodKodi").style.borderColor = "red";
    }
    this.setState({ errors: errors });
    return formIsValid;
  }
  convertToDropDown = (par) => {
    var ret = [];
    var paramArray = par;

    for (var i in paramArray) {
      var objItem = { value: "", label: "" };
      objItem.value = paramArray[i];
      objItem.label = paramArray[i];
      ret.push(objItem);
    }

    return ret;
  };

  handleClick = (e) => {
    
    // const req = {
    //   PodKodi: this.state.PodKodi,
    //   Marresi: this.state.Marresi,
    //   PerdoruesId: "xhoiID",
    //   Korrieri: this.state.Korrieri.value
    // };
    // for (var i = 0; i <= this.state.posts.length; i++) {
    //   var pod = this.state.posts[i];

    //   console.log("reqPod", pod);
    // }

    // this.state.PodKodi.push(pod);

  
    const req = {
      PodKodi: this.state.posts,
      Perdorues: window.UserP.username,
      AgjensiBurim: window.UserP.agencyId,
      Korrieri: this.state.Korrieri.value,
      Terminal: window.UserP.idProcesori,
      Token: HmacSHA256(
        Math.round(new Date().getTime() / 1000).toString(),
        window.UserP.key
      ).toString(),
    username: window.UserP.username,
    };

    // var posts1 = [...this.state.posts];

    // posts1.push(req);

  

    // this.setState({posts: posts1  });

    //  console.log("log", this.state.posts);
    this.setState({ loading: true }, () => {
    if (this.state.posts.length!=0  ) {
      axios
        .post(window.UserP.url + "POD/DelegoKorrier", req)
        .then((response) => {
          for (var i in response.data) {
            const searchresults = response.data[i];

            // for (var i in response.data) {
            let statusi = searchresults.ResultDescription; //response.data.ResultDescription;

            if (searchresults.Result === true) {
              this.setState({
                showModal: true,
                loading: false,
                errors: searchresults.ResultDescription,
                selected: false,
                error1: searchresults.ResultDescription,
              });
              this.state.statusi.push(statusi);

              this.showErrors();
        
            } else {
              this.setState({
                showModal: true,
                loading: false,
                errors: searchresults.ResultDescription,
                selected: true,
                error1: searchresults.Error + searchresults.ResultDescription,
                // posts: posts1
              });
              this.state.statusi.push(statusi);
              this.showErrors();
              // document.getElementById("2").style.borderColor = "red";
              
            }
          }
 
        })
      .catch(error => {
        this.setState({
          loading: false,
          error1: "Ju lutem kontaktoni departamentin e IT!"
        });
        this.showErrors();
      });
    }

    else 
    {
      this.setState({
        showModal: true,
        loading: false,
    
        selected: false,
        error1: "Ju lutem plotesoni te dhenat!",
      });
    }

  })

  };

  componentDidMount() {
    fetch(window.UserP.url + "POD/GetKodKorrieri", {
      method: "Post",
      headers: {
        Accept: "application/json",
        "Content-type": "application/json",
        "Access-Control-Allow-Origin": "*",
      },
      body: JSON.stringify({
        Token: HmacSHA256(
          Math.round(new Date().getTime() / 1000).toString(),
          window.UserP.key
        ).toString(),
        username: window.UserP.username,
        Id: window.UserP.agency,
      }),
    })
      .then((res) => res.json())
      .then((data) => this.setState({ data2: data, }));
  }

  showModal = () => {
    this.setState({ show: true });
   
  };

  handleInputChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({ [name]: value.toUpperCase() });
  };

  OnEnterPress = (e) => {
    if(e.keyCode === 13){
        this.handleClickModal(e);
        this.setState({
            PodKodi:""
        })
    }
  };


  
  resetInput = (e) => {
    this.setState({
      PodKodi: [],
      posts: [],
      Perdorues: "",
      data2: [],
      Korrieri: "",
      errors: "",
      alert: null,
      statusi: [],
      selected: false,
      agjensi: "",
      loading: false,
      loading2: false
    });
  };

  handleClickModal = (e) => {
    e.preventDefault();

    //let p = this.state.people.slice();
    //p.push({id: "", key: ""});
    //this.setState({people: p});

    var posts = [...this.state.posts];
  
    // var posts = [...this.state.posts];
    if (this.handleValidation(posts)) {
      posts.push(this.state.PodKodi);

      this.setState({ posts: posts });
      document.getElementById("PodKodi").style.borderColor = ""; // alert("Form submitted");
   
    } else {
    }
    this.setState({
      PodKodi:"",
    })
  };

  onChangeFunc = (name) => (value) => {
  
    this.setState({
      [name]: value,
    });
    if (
      // value.label === "D2DK" ||
      // value.label === "P2PK" ||
      // value.label === "LEKE" ||
      // value.label === "EURO"
      value.label === "D2D" ||
      value.label === "P2P"
    ) {
      this.setState({ showText: false });
    } else {
      this.setState({ showText: true });
    }
  };
  render() {
    const columns = [
      {
        Header: "Nr",
        accessor: "",
        id: "row",
        maxWidth: 50,
        filterable: false,
        Cell: (row) => {
          return <div>{row.index + 1}</div>;
        },
      },
      {
        Header: "Kodi i Njesise",
        accessor: "",
        Cell: "",
        maxWidth: 150,
        filterable: false,
      },
      {
        Header: "Status",
        accessor: "4",

        Cell: (statusi) => (
          <span className="number">{this.state.statusi[statusi.index]}</span>
        ),
      },
      {
        Header: "Fshi",
        id: "Fshi",
        accessor: (str) => "Fshi",
        maxWidth: 100,
        filterable: false,

        Cell: (row) => (
          <span
            style={{
              cursor: "pointer",
              color: "blue",
              textDecoration: "underline",
            }}
            onClick={() => {
              let data = this.state.posts;
              data.splice(row.index, 1);
              this.setState({
                posts: data,
                cope: data.length + 1,
              });
            }}
          >
            Delete
          </span>
        ),
      },
    ];
    return (
      <div>
      {this.state.loading ? (
        <LoadingSpinner />
      ) : (
      <div className="Form">
        <div className="card card-body bg-light col-md-8 mt-4">
          <div className="col-md-7">
            {" "}
            <label className="m-2">Kodi i Korrierit</label>
            <Select
              id="9"
              value={this.state.Korrieri}
              onChange={this.onChangeFunc("Korrieri")}
              options={this.convertToDropDown(this.state.data2)}
            />
          </div>
          <div className="col-md-7">
            <label className="m-2">Nr. POD</label>
            <input
              id="PodKodi"
              name="PodKodi"
              value={this.state.PodKodi}
              className="form-control "
              type="text"
              onChange={(e) => this.handleInputChange(e, "PodKodi")}
              onKeyUp={this.OnEnterPress}
            />
            <span style={{ color: "red" }}>{this.state.errors["name"]}</span>
          </div>
          <div className="col-md-3">
            <button
              className="btn btn-primary  mt-4"
              onClick={this.handleClickModal}
            >
              <span data-notify="icon" className="pe-7s-plus" />
              &nbsp; Shto ne liste
            </button>
          </div>
        </div>{" "}
        <div className="card card-body bg-light col-md-12 mt-4">
          <ReactTable
            //className="-striped"
            columns={columns}
            data={this.state.posts}
            pivotColumnWidth={2}
            defaultPageSize={5}
            className="-striped -highlight mt-4"
            pageText="Faqe"
            nextText="Para"
            rowsText="Rreshta"
            previousText="Mbrapa"
            noDataText="Nuk ka te dhena"
            maxWidth={150}
            getTrProps={(state, rowInfo) => {
              if (rowInfo && rowInfo.row && this.state.selected) {
               
                return {
                  style: {
                    background:
                      rowInfo.index === this.state.selected ? "" : "#FA8072",
                    color: rowInfo.index === this.state.selected ? "" : "red",
                  },
                };
              } else {
                return {};
              }
            }}
          />
        </div>
        <button className="btn btn-primary " onClick={this.handleClick}>
          <span data-notify="icon" className="pe-7s-diskette" />
          &nbsp; Ruaj
        </button>
        <button className="btn btn-primary ml-4 "onClick={this.resetInput}>
          <span data-notify="icon" className="pe-7s-trash" />
          &nbsp; Pastro
        </button>
      </div>
    )

    }
    </div>

    )
  }
}


const Modal = ({ handleClose, show, children }) => {
  const showHideClassName = show ? "modal display-block" : "modal display-none";

  return (
    <div className={showHideClassName}>
      <section className="modal-main">
        {children}
        <button className="btn btn-primary btn-sm m-2" onClick={handleClose}>
          Ruaj&MByll
        </button>
      </section>
    </div>
  );
};

export const Modal2 = ({ handleClose, showModal, children }) => {
  const showHideClassName = showModal
    ? "modal display-block"
    : "modal display-none";

  return (
    <div className={showHideClassName}>
      <section className="modal-main">
        {children}
        <button className="btn btn-primary btn-sm m-2" onClick={handleClose}>
          MByll
        </button>
      </section>
    </div>
  );
};


export default ShperndaKorrier;
